import React, {Component} from 'react';
import axios from 'axios';
import * as ReactBootStrap from 'react-bootstrap';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';
import '../tools/css/ConfigHistoriaClinica.css';
import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

const ApiURL = process.env.REACT_APP_API_URL;

// Catálogo de "tipos de campo" en lenguaje sencillo: quien configura la
// historia clínica no tiene por qué saber qué es un "control" o un "type"
// del JSON; elige uno de estos y nosotros lo traducimos a las propiedades
// reales que espera ConfigClinicalHistory/Create.
const TIPOS_CAMPO = [
  { id:'texto_corto', etiqueta:'Texto corto', icono:'fa-font', ayuda:'Una línea de texto libre. Ej: motivo de consulta.' },
  { id:'texto_largo', etiqueta:'Texto largo', icono:'fa-align-left', ayuda:'Varias líneas de texto libre. Ej: descripción, observaciones.' },
  { id:'numero', etiqueta:'Número', icono:'fa-hashtag', ayuda:'Un valor numérico. Ej: peso, talla, frecuencia cardiaca.' },
  { id:'fecha', etiqueta:'Fecha', icono:'fa-calendar-alt', ayuda:'Un día del calendario. Ej: fecha de inicio de síntomas.' },
  { id:'fecha_hora', etiqueta:'Fecha y hora', icono:'fa-clock', ayuda:'Un día y una hora exacta.' },
  { id:'si_no', etiqueta:'Sí / No', icono:'fa-toggle-on', ayuda:'Una pregunta que se responde marcando Sí o No.' },
  { id:'lista_desplegable', etiqueta:'Lista desplegable', icono:'fa-caret-square-down', ayuda:'El usuario elige UNA opción de una lista que tú defines.' },
  { id:'lista_multiple', etiqueta:'Selección múltiple', icono:'fa-tasks', ayuda:'El usuario puede elegir VARIAS opciones de una lista que tú defines.' },
  { id:'opciones_botones', etiqueta:'Opciones en botones', icono:'fa-dot-circle', ayuda:'Como una lista, pero mostrando las opciones visibles. Ideal para pocas opciones.' },
  { id:'catalogo', etiqueta:'Catálogo del sistema', icono:'fa-book-medical', ayuda:'El usuario elige de un catálogo ya existente. Ej: diagnósticos, medicamentos.' },
  { id:'tabla', etiqueta:'Tabla repetible', icono:'fa-table', ayuda:'Permite agregar varias filas con columnas que tú defines. Ej: lista de medicamentos formulados.' },
  { id:'calculado', etiqueta:'Campo calculado', icono:'fa-calculator', ayuda:'Un valor que el sistema calcula automáticamente. Ej: IMC a partir de peso y talla.' }
];

const ANCHOS = [
  { valor:2, etiqueta:'Pequeño', ayuda:'Comparte la fila con otros campos' },
  { valor:6, etiqueta:'Mediano', ayuda:'Comparte la fila con 1 campo más' },
  { valor:12, etiqueta:'Grande', ayuda:'Ocupa toda la fila' }
];

// El valor que se guarda es el slug real que espera el backend (confirmado
// para cie10/medicamentos); el nombre es solo lo que se muestra en el
// selector.
const CATALOGOS_SUGERIDOS = [
  { name:'Diagnósticos CIE-10', value:'cie10' },
  { name:'Medicamentos', value:'medicamentos' },
  { name:'Procedimientos', value:'procedimientos' },
  { name:'Laboratorios', value:'laboratorios' }
];

// Formato de historia clínica prediseñado por Medicall24: los campos mínimos
// normativos para el diligenciamiento de una historia clínica en Colombia.
// Se ofrece como punto de partida al crear una plantilla nueva (modal de
// "¿Desea cargar el formato...?" y botón "Cargar formato").
const PLANTILLA_MEDICALL24 = {
  "name": "Plantilla de referencia",
  "specialtyId": 1,
  "requirePrescription": true,
  "requireOrder": true,
  "requireIncapacity": false,
  "isControl": false,
  "historyFields": [
    {
      "code": "servicio_ingreso",
      "label": "FINALIDAD DE LA ATENCIÓN",
      "type": "lista",
      "required": true,
      "section": "Datos de ingreso",
      "width": 12,
      "control": "desplegable",
      "options": [
        { "value": "CE", "name": "Consulta externa" },
        { "value": "UR", "name": "Urgencias" },
        { "value": "HO", "name": "Hospitalización" }
      ]
    },
    {
      "code": "fecha_atencion",
      "label": "FECHA Y HORA DE ATENCIÓN",
      "type": "fecha",
      "required": true,
      "section": "Datos de ingreso",
      "width": 12,
      "withTime": true
    },
    {
      "code": "motivo_consulta",
      "label": "MOTIVO DE CONSULTA",
      "type": "texto",
      "required": true,
      "width": 12,
      "maxLength": 2000
    },
    {
      "code": "enfermedad_actual",
      "label": "ENFERMEDAD ACTUAL",
      "type": "texto",
      "required": true,
      "width": 12,
      "maxLength": 4000,
      "multiline": true
    },
    {
      "code": "revision_sistemas",
      "label": "REVISIÓN POR SISTEMAS",
      "type": "texto",
      "required": true,
      "width": 12,
      "maxLength": 4000,
      "multiline": true
    },
    {
      "code": "antecedentes_gineco_obstetricos",
      "label": "ANTECEDENTES GINECO-OBSTÉTRICOS",
      "type": "texto",
      "section": "ANTECEDENTES",
      "width": 12,
      "visibleForSex": ["F"],
      "antecedent": true,
      "maxLength": 1000,
      "multiline": true
    },
    {
      "code": "tiene_ant_patologicos",
      "label": "ANTECEDENTES PATOLÓGICOS",
      "type": "booleano",
      "section": "ANTECEDENTES",
      "width": 12,
      "antecedent": true
    },
    {
      "code": "ant_patologicos",
      "label": "DIAGNÓSTICOS CONOCIDOS",
      "type": "lista",
      "section": "ANTECEDENTES",
      "width": 12,
      "antecedent": true,
      "control": "desplegable",
      "multiSelect": true,
      "catalog": "cie10",
      "visibleIf": { "fieldCode": "tiene_ant_patologicos", "equalTo": "Sí" }
    },
    {
      "code": "ant_quirurgicos",
      "label": "ANTECEDENTES QUIRÚRGICOS",
      "type": "texto",
      "section": "ANTECEDENTES",
      "width": 12,
      "antecedent": true,
      "maxLength": 2000,
      "multiline": true
    },
    {
      "code": "tiene_alergicos",
      "label": "ALÉRGICOS",
      "type": "booleano",
      "required": true,
      "section": "ANTECEDENTES ESPECÍFICOS - RDA",
      "width": 12,
      "antecedent": true
    },
    {
      "code": "detalle_alergicos",
      "label": "ANTECEDENTES ALÉRGICOS",
      "type": "tabla",
      "section": "ANTECEDENTES ESPECÍFICOS - RDA",
      "width": 12,
      "antecedent": true,
      "visibleIf": { "fieldCode": "tiene_alergicos", "equalTo": "Sí" },
      "columns": [
        {
          "code": "tipo_alergia",
          "label": "Tipo de alergia",
          "type": "lista",
          "antecedent": true,
          "control": "desplegable",
          "options": [
            { "value": "01", "name": "Medicamento" },
            { "value": "02", "name": "Alimento" },
            { "value": "03", "name": "Sustancia del ambiente" },
            { "value": "04", "name": "Sustancias que entran en contacto con la piel" },
            { "value": "05", "name": "Picadura de insectos" },
            { "value": "06", "name": "Otras" }
          ]
        },
        {
          "code": "nombre_alergeno",
          "label": "Nombre del alérgeno",
          "type": "texto",
          "antecedent": true,
          "maxLength": 100
        }
      ]
    },
    {
      "code": "tiene_familiares",
      "label": "FAMILIARES",
      "type": "booleano",
      "required": true,
      "section": "ANTECEDENTES ESPECÍFICOS - RDA",
      "width": 12,
      "antecedent": true
    },
    {
      "code": "detalle_familiares",
      "label": "ANTECEDENTES FAMILIARES",
      "type": "tabla",
      "section": "ANTECEDENTES ESPECÍFICOS - RDA",
      "width": 12,
      "antecedent": true,
      "visibleIf": { "fieldCode": "tiene_familiares", "equalTo": "Sí" },
      "columns": [
        {
          "code": "parentesco",
          "label": "Parentesco",
          "type": "lista",
          "antecedent": true,
          "control": "desplegable",
          "options": [
            { "value": "PA", "name": "Padre" },
            { "value": "MA", "name": "Madre" },
            { "value": "HE", "name": "Hermano(a)" },
            { "value": "AB", "name": "Abuelo(a)" },
            { "value": "TI", "name": "Tío(a)" },
            { "value": "HI", "name": "Hijo(a)" },
            { "value": "OT", "name": "Otro" }
          ]
        },
        {
          "code": "diagnostico",
          "label": "Diagnóstico",
          "type": "lista",
          "antecedent": true,
          "control": "desplegable",
          "catalog": "cie10"
        }
      ]
    },
    {
      "code": "tiene_farmacologicos",
      "label": "FARMACOLÓGICOS",
      "type": "booleano",
      "required": true,
      "section": "ANTECEDENTES ESPECÍFICOS - RDA",
      "width": 12,
      "antecedent": true
    },
    {
      "code": "detalle_farmacologicos",
      "label": "ANTECEDENTES FARMACOLÓGICOS",
      "type": "tabla",
      "section": "ANTECEDENTES ESPECÍFICOS - RDA",
      "width": 12,
      "antecedent": true,
      "visibleIf": { "fieldCode": "tiene_farmacologicos", "equalTo": "Sí" },
      "columns": [
        {
          "code": "medicamento",
          "label": "Medicamento",
          "type": "lista",
          "antecedent": true,
          "control": "desplegable",
          "catalog": "medicamentos"
        }
      ]
    },
    {
      "code": "factor_riesgo",
      "label": "¿Identificó en esta consulta algún factor de riesgo latente que condicione el pronóstico o plan de manejo a largo plazo del paciente?",
      "type": "booleano",
      "section": "FACTORES DE RIESGO",
      "width": 12,
      "antecedent": true
    },
    {
      "code": "detalle_factor_riesgo",
      "label": "FACTORES DE RIESGO",
      "type": "tabla",
      "required": true,
      "section": "FACTORES DE RIESGO",
      "width": 12,
      "visibleIf": { "fieldCode": "factor_riesgo", "equalTo": "Sí" },
      "columns": [
        {
          "code": "tipo_factor_riesgo",
          "label": "Tipo de factor de riesgo",
          "type": "lista",
          "control": "desplegable",
          "options": [
            { "value": "01", "name": "Químicos" },
            { "value": "02", "name": "Físicos" },
            { "value": "03", "name": "Biomecánicos" },
            { "value": "04", "name": "Psicosociales" },
            { "value": "05", "name": "Biológicos" },
            { "value": "06", "name": "Otros" }
          ]
        },
        {
          "code": "nombre_factor_riesgo",
          "label": "Nombre del factor de riesgo",
          "type": "texto",
          "maxLength": 100
        }
      ]
    },
    {
      "code": "habitos",
      "label": "HÁBITOS",
      "type": "texto",
      "required": true,
      "width": 12,
      "antecedent": true,
      "maxLength": 1000,
      "multiline": true
    },
    {
      "code": "peso",
      "label": "Peso (Kg)",
      "type": "numero",
      "section": "SIGNOS VITALES",
      "width": 6
    },
    {
      "code": "talla",
      "label": "Talla (Mts)",
      "type": "numero",
      "section": "SIGNOS VITALES",
      "width": 6
    },
    {
      "code": "imc",
      "label": "IMC",
      "type": "numero",
      "section": "SIGNOS VITALES",
      "width": 6,
      "calculated": "peso / (talla * talla)",
      "decimals": 2
    },
    {
      "code": "tas",
      "label": "TAS (mmHg)",
      "type": "numero",
      "section": "SIGNOS VITALES",
      "width": 6
    },
    {
      "code": "tad",
      "label": "TAD (mmHg)",
      "type": "numero",
      "section": "SIGNOS VITALES",
      "width": 6
    },
    {
      "code": "tam",
      "label": "TAM (mmHg)",
      "type": "numero",
      "section": "SIGNOS VITALES",
      "width": 6,
      "calculated": "(tas + 2 * tad) / 3",
      "decimals": 1
    },
    {
      "code": "fc",
      "label": "FC (lpm)",
      "type": "numero",
      "section": "SIGNOS VITALES",
      "width": 6
    },
    {
      "code": "fr",
      "label": "FR (rpm)",
      "type": "numero",
      "section": "SIGNOS VITALES",
      "width": 6
    },
    {
      "code": "temperatura",
      "label": "Temperatura (°C)",
      "type": "numero",
      "section": "SIGNOS VITALES",
      "width": 6
    },
    {
      "code": "sato2",
      "label": "Sat O2 (%)",
      "type": "numero",
      "section": "SIGNOS VITALES",
      "width": 6
    },
    {
      "code": "ef_conciencia",
      "label": "ESTADO DE CONCIENCIA",
      "type": "texto",
      "section": "EXAMEN FÍSICO",
      "width": 12,
      "maxLength": 1000,
      "multiline": true
    },
    {
      "code": "ef_neurologico",
      "label": "NEUROLÓGICO Y MENTAL",
      "type": "texto",
      "section": "EXAMEN FÍSICO",
      "width": 12,
      "maxLength": 1000,
      "multiline": true
    },
    {
      "code": "ef_cabeza_cuello",
      "label": "CABEZA/CUELLO/ÓRGANOS DE LOS SENTIDOS",
      "type": "texto",
      "section": "EXAMEN FÍSICO",
      "width": 12,
      "maxLength": 1000,
      "multiline": true
    },
    {
      "code": "ef_torax",
      "label": "TÓRAX",
      "type": "texto",
      "section": "EXAMEN FÍSICO",
      "width": 12,
      "maxLength": 1000,
      "multiline": true
    },
    {
      "code": "ef_cardiopulmonar",
      "label": "CARDIOPULMONAR",
      "type": "texto",
      "section": "EXAMEN FÍSICO",
      "width": 12,
      "maxLength": 1000,
      "multiline": true
    },
    {
      "code": "ef_abdomen",
      "label": "ABDOMEN",
      "type": "texto",
      "section": "EXAMEN FÍSICO",
      "width": 12,
      "maxLength": 1000,
      "multiline": true
    },
    {
      "code": "ef_genitourinario",
      "label": "GENITOURINARIO",
      "type": "texto",
      "section": "EXAMEN FÍSICO",
      "width": 12,
      "maxLength": 1000,
      "multiline": true
    },
    {
      "code": "ef_extremidades",
      "label": "EXTREMIDADES Y OTROS",
      "type": "texto",
      "section": "EXAMEN FÍSICO",
      "width": 12,
      "maxLength": 1000,
      "multiline": true
    },
    {
      "code": "interpretacion_paraclinica",
      "label": "INTERPRETACIÓN DEL PARACLÍNICO Y/O IMÁGENES",
      "type": "texto",
      "width": 12,
      "maxLength": 4000,
      "multiline": true
    },
    {
      "code": "analisis",
      "label": "ANÁLISIS",
      "type": "texto",
      "required": true,
      "width": 12,
      "maxLength": 4000,
      "multiline": true
    },
    {
      "code": "plan_tratamiento",
      "label": "PLAN DE TRATAMIENTO",
      "type": "texto",
      "required": true,
      "width": 12,
      "maxLength": 4000,
      "multiline": true
    }
  ]
};

// Solo para el modo prueba: como acá no hay un catálogo real conectado, se
// simula cada uno con unos pocos datos de ejemplo para que el campo se vea y
// se comporte como una lista de verdad (no como un campo de texto libre).
const DATOS_CATALOGO_PRUEBA = {
  cie10: [
    { value:'A00', name:'A00 - Cólera' },
    { value:'J00', name:'J00 - Rinofaringitis aguda (resfriado común)' },
    { value:'I10', name:'I10 - Hipertensión esencial' },
    { value:'E11', name:'E11 - Diabetes mellitus tipo 2' },
    { value:'K29', name:'K29 - Gastritis y duodenitis' }
  ],
  medicamentos: [
    { value:'acetaminofen', name:'Acetaminofén' },
    { value:'ibuprofeno', name:'Ibuprofeno' },
    { value:'amoxicilina', name:'Amoxicilina' },
    { value:'loratadina', name:'Loratadina' },
    { value:'omeprazol', name:'Omeprazol' }
  ],
  procedimientos: [
    { value:'hemograma', name:'Hemograma completo' },
    { value:'rx_torax', name:'Radiografía de tórax' },
    { value:'ecografia_abdominal', name:'Ecografía abdominal' },
    { value:'electrocardiograma', name:'Electrocardiograma' }
  ],
  laboratorios: [
    { value:'glicemia', name:'Glicemia en ayunas' },
    { value:'creatinina', name:'Creatinina sérica' },
    { value:'perfil_lipidico', name:'Perfil lipídico' },
    { value:'uroanalisis', name:'Uroanálisis' }
  ]
};

function generarCodigo(texto){
  return (texto || '')
    .toString()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 40);
}

function campoVacio(){
  return {
    tipoCampo: '',
    code: '',
    label: '',
    required: false,
    section: '',
    width: 6,
    maxLength: '',
    multiline: false,
    withTime: false,
    control: '',
    multiSelect: false,
    options: [],
    catalog: '',
    max: '',
    decimals: 0,
    visibleIf: { fieldCode:'', equalTo:'' },
    visibleForSex: [],
    antecedent: false,
    columns: [],
    calculated: '',
    defaultValue: [],
    // Solo true para los campos que llegan con la plantilla prediseñada de
    // Medicall24 (ver cargarPlantillaMedicall24): bloquea su eliminación,
    // pero se pueden personalizar sus demás atributos libremente.
    esNormativo: false
  };
}

const ETIQUETAS_TIPO_COLUMNA = {
  texto: 'texto',
  numero: 'número',
  lista: 'lista',
  lista_catalogo: 'catálogo'
};

function columnaVacia(){
  return {
    label: '',
    tipoColumna: 'texto',
    options: [],
    catalog: '',
    maxLength: ''
  };
}

// Traduce el "tipo de campo" en lenguaje sencillo a las propiedades reales
// que espera el endpoint. OJO: el vocabulario real (confirmado con una
// configuración que sí se guardó) es en español — "texto"/"numero"/"fecha"/
// "booleano"/"lista"/"tabla" — no "string"/"number"/"date"/etc. Para
// "Opciones en botones" no hay un valor de control distinto confirmado, así
// que por ahora se guarda igual que "Lista desplegable" (control:"desplegable").
function propiedadesDesdeTipo(tipoId){
  switch(tipoId){
    case 'texto_corto': return { type:'texto', control:null, multiline:false };
    case 'texto_largo': return { type:'texto', control:null, multiline:true };
    case 'numero': return { type:'numero', control:null };
    case 'fecha': return { type:'fecha', control:null, withTime:false };
    case 'fecha_hora': return { type:'fecha', control:null, withTime:true };
    case 'si_no': return { type:'booleano', control:null };
    case 'lista_desplegable': return { type:'lista', control:'desplegable', multiSelect:false };
    case 'lista_multiple': return { type:'lista', control:'desplegable', multiSelect:true };
    case 'opciones_botones': return { type:'lista', control:'desplegable', multiSelect:false };
    case 'catalogo': return { type:'lista', control:'desplegable' };
    case 'tabla': return { type:'tabla', control:null };
    case 'calculado': return { type:'numero', control:null };
    default: return { type:'texto', control:null };
  }
}

// Camino inverso: al editar una historia clínica ya creada, el endpoint
// devuelve historyFields con type/control en español, así que hay que
// reconocer de nuevo cuál tarjeta de TIPOS_CAMPO corresponde a cada campo.
function tipoCampoDesdeHistoryField(campo){
  const type = campo.type;

  if(type==='texto') return campo.multiline ? 'texto_largo' : 'texto_corto';
  if(type==='numero') return campo.calculado ? 'calculado' : 'numero';
  if(type==='fecha') return campo.withTime ? 'fecha_hora' : 'fecha';
  if(type==='booleano') return 'si_no';
  if(type==='lista') {
    if(campo.catalog) return 'catalogo';
    return campo.multiSelect ? 'lista_multiple' : 'lista_desplegable';
  }
  if(type==='tabla') return 'tabla';
  return 'texto_corto';
}

// Igual que tipoCampoDesdeHistoryField, pero para las columnas de una tabla
// (que son mini-campos con su propio type/control/options/catalog).
function tipoColumnaDesdeApi(col){
  if(col.type==='lista') return col.catalog ? 'lista_catalogo' : 'lista';
  if(col.type==='numero') return 'numero';
  return 'texto';
}

function columnaDesdeApi(col){
  return {
    code: col.code || '',
    label: col.label || '',
    tipoColumna: tipoColumnaDesdeApi(col),
    options: col.options || [],
    catalog: col.catalog || '',
    maxLength: col.maxLength || ''
  };
}

function campoDesdeHistoryField(hf){
  return {
    tipoCampo: tipoCampoDesdeHistoryField(hf),
    type: hf.type || '',
    code: hf.code || '',
    label: hf.label || '',
    required: !!hf.required,
    section: hf.section || '',
    width: hf.width || hf.ancho || 12,
    maxLength: hf.maxLength || '',
    multiline: !!hf.multiline,
    withTime: !!hf.withTime,
    control: hf.control || '',
    multiSelect: !!hf.multiSelect,
    options: hf.options || [],
    catalog: hf.catalog || '',
    max: hf.max || '',
    decimals: hf.decimales || 0,
    visibleIf: (hf.visibleIf && hf.visibleIf.fieldCode) ? hf.visibleIf : { fieldCode:'', equalTo:'' },
    visibleForSex: hf.visibleForSex || [],
    antecedent: !!hf.antecedent,
    columns: (hf.columns || []).map(columnaDesdeApi),
    calculated: hf.calculado || '',
    defaultValue: hf.defaultValue || []
  };
}

// PLANTILLA_MEDICALL24 usa "calculated"/"decimals" (inglés) para sus dos
// campos calculados (igual que el payload de ejemplo), pero campoDesdeHistoryField
// espera el vocabulario real del backend ("calculado"/"decimales", en
// español). Se traduce una sola vez, acá, al cargar la plantilla.
function normalizarCampoPlantilla(hf){
  const normalizado = { ...hf };
  if(normalizado.calculated && !normalizado.calculado) normalizado.calculado = normalizado.calculated;
  if(normalizado.decimals !== undefined && normalizado.decimales === undefined) normalizado.decimales = normalizado.decimals;
  return normalizado;
}

function notifExito(mensaje){
  return {
    title:'Muy bien',
    message: mensaje,
    type:'success',
    container:'top-right',
    animationIn:["animated", "fadeIn"],
    animationOut:["animated", "fadeOut"],
    dismiss:{ duration:8000, showIcon:true }
  };
}

function notifAtencion(mensaje){
  return {
    title:'Atención',
    message: mensaje,
    type:'danger',
    container:'top-right',
    animationIn:["animated", "fadeIn"],
    animationOut:["animated", "fadeOut"],
    dismiss:{ duration:8000, showIcon:true }
  };
}

class ConfigHistoriaClinica extends Component {

  constructor(){
    super();
    this.state = {
      nombre: '',
      specialtyId: '',
      especialidades: [],
      requirePrescription: false,
      requireOrder: false,
      requireIncapacity: false,
      isControl: false,
      campos: [],
      campoActual: campoVacio(),
      indiceEditando: null,
      mostrarAvanzado: false,
      opcionNueva: '',
      valorOpcionNueva: '',
      columnaNueva: columnaVacia(),
      opcionColumnaNueva: '',
      valorOpcionColumnaNueva: '',
      guardando: false,
      idHistoriaEditando: new URLSearchParams(window.location.search).get('id') || null,
      cargandoHistoria: false,
      valoresPrueba: {},
      filasTablaPrueba: {},
      sexoPrueba: ''
    };
  }

  componentDidMount(){
    this.cargarEspecialidades();
    if(this.state.idHistoriaEditando){
      this.cargarHistoriaParaEditar();
    }else{
      // Nueva plantilla: le ofrecemos de entrada el formato prediseñado.
      this.abrirModalCargarPlantilla();
    }
  }

  /** Muestra el modal "¿Desea cargar el formato...?" — se usa tanto al entrar a crear como desde el botón "Cargar formato". */
  abrirModalCargarPlantilla = () => {
    $('#modal-cargar-plantilla').modal('show');
  };

  /**
   * Botón "Sí, cargar": trae el formato prediseñado por Medicall24 (campos
   * mínimos normativos) como punto de partida editable. No toca el nombre ni
   * la especialidad (eso lo define el usuario); sí reemplaza los indicadores
   * del encabezado y la lista de campos — si ya había campos agregados
   * manualmente, se pierden.
   */
  cargarPlantillaMedicall24 = () => {
    this.setState({
      requirePrescription: !!PLANTILLA_MEDICALL24.requirePrescription,
      requireOrder: !!PLANTILLA_MEDICALL24.requireOrder,
      requireIncapacity: !!PLANTILLA_MEDICALL24.requireIncapacity,
      isControl: !!PLANTILLA_MEDICALL24.isControl,
      campos: (PLANTILLA_MEDICALL24.historyFields || []).map((hf) => ({ ...campoDesdeHistoryField(normalizarCampoPlantilla(hf)), esNormativo: true }))
    }, () => {
      $('#modal-cargar-plantilla').modal('hide');
      store.addNotification(notifExito("Se cargó el formato prediseñado de Medicall24. Ya puedes ajustarlo a tu necesidad."));
    });
  };

  cargarEspecialidades(){
    axios.get(ApiURL + "/api/Specialties")
    .then((response) => {
      this.setState({ especialidades: response.data || [] });
    })
    .catch((error) => {
      console.log(error);
    });
  }

  // Trae la configuración ya guardada de la historia clínica que se va a
  // editar y la traduce de vuelta al formato interno del constructor.
  cargarHistoriaParaEditar(){
    this.setState({ cargandoHistoria:true });

    axios.get(ApiURL + "/api/ConfigClinicalHistory/GetById/" + this.state.idHistoriaEditando)
    .then((response) => {
      console.log(response);
      const datos = response.data || {};
      this.setState({
        nombre: datos.name || '',
        specialtyId: datos.specialtyId || '',
        requirePrescription: !!datos.requirePrescription,
        requireOrder: !!datos.requireOrder,
        requireIncapacity: !!datos.requireIncapacity,
        isControl: !!datos.isControl,
        campos: (datos.historyFields || []).map(campoDesdeHistoryField),
        cargandoHistoria:false
      });
    })
    .catch((error) => {
      console.log(error);
      store.addNotification(notifAtencion("No se pudo cargar la historia clínica para editar"));
      this.setState({ cargandoHistoria:false });
    });
  }

  handleChangeNombre = (e) => this.setState({ nombre: e.target.value });
  handleChangeSpecialty = (e) => this.setState({ specialtyId: e.target.value });
  handleToggleEncabezado = (campo) => this.setState({ [campo]: !this.state[campo] });

  seleccionarTipoCampo = (tipoId) => {
    this.setState((prevState) => ({
      campoActual: {
        ...prevState.campoActual,
        tipoCampo: tipoId,
        ...propiedadesDesdeTipo(tipoId)
      }
    }));
  };

  handleChangeCampo = (propiedad, valor) => {
    this.setState((prevState) => {
      const campoActual = { ...prevState.campoActual, [propiedad]: valor };
      if(propiedad==='label' && prevState.indiceEditando===null){
        campoActual.code = generarCodigo(valor);
      }
      return { campoActual };
    });
  };

  handleChangeVisibleIf = (propiedad, valor) => {
    this.setState((prevState) => ({
      campoActual: {
        ...prevState.campoActual,
        visibleIf: { ...prevState.campoActual.visibleIf, [propiedad]: valor }
      }
    }));
  };

  handleToggleSexo = (sexo) => {
    this.setState((prevState) => {
      const actuales = prevState.campoActual.visibleForSex || [];
      const yaEsta = actuales.includes(sexo);
      const nuevos = yaEsta ? actuales.filter((s) => s!==sexo) : [...actuales, sexo];
      return { campoActual: { ...prevState.campoActual, visibleForSex: nuevos } };
    });
  };

  // "defaultValue" se guarda siempre como arreglo (así lo espera el backend);
  // para los campos de un solo valor (texto, número, fecha, Sí/No, lista de
  // una sola opción) el arreglo solo tiene 0 o 1 elementos.
  handleChangeDefaultValueUnico = (valor) => {
    this.setState((prevState) => ({
      campoActual: { ...prevState.campoActual, defaultValue: (valor===undefined || valor===null || valor==='') ? [] : [String(valor)] }
    }));
  };

  handleToggleDefaultValueMultiple = (valor) => {
    this.setState((prevState) => {
      const actuales = prevState.campoActual.defaultValue || [];
      const nuevos = actuales.includes(valor) ? actuales.filter((v) => v!==valor) : [...actuales, valor];
      return { campoActual: { ...prevState.campoActual, defaultValue: nuevos } };
    });
  };

  // El catálogo real no está disponible en este editor, así que el valor
  // predeterminado se escribe a mano (un código, o varios separados por
  // coma si el campo permite elegir varias opciones del catálogo).
  handleChangeDefaultValueCatalogo = (texto) => {
    const multiSelect = this.state.campoActual.multiSelect;
    const valores = multiSelect
      ? texto.split(',').map((v) => v.trim()).filter((v) => v)
      : (texto.trim() ? [texto.trim()] : []);
    this.setState((prevState) => ({ campoActual: { ...prevState.campoActual, defaultValue: valores } }));
  };

  /** Editor del "Valor predeterminado": un control distinto según el tipo de campo elegido. */
  renderValorPredeterminado = () => {
    const { campoActual } = this.state;
    const valorUnico = (campoActual.defaultValue && campoActual.defaultValue[0]) || '';

    switch(campoActual.tipoCampo){
      case 'texto_corto':
        return (
          <div className="form-group">
            <label>Valor predeterminado (opcional)</label>
            <input type="text" className="form-control" placeholder="Se mostrará ya escrito al abrir el campo" value={valorUnico} onChange={(e) => this.handleChangeDefaultValueUnico(e.target.value)}/>
          </div>
        );
      case 'texto_largo':
        return (
          <div className="form-group">
            <label>Valor predeterminado (opcional)</label>
            <textarea className="form-control" rows="2" placeholder="Se mostrará ya escrito al abrir el campo" value={valorUnico} onChange={(e) => this.handleChangeDefaultValueUnico(e.target.value)}></textarea>
          </div>
        );
      case 'numero':
        return (
          <div className="form-group">
            <label>Valor predeterminado (opcional)</label>
            <input type="number" className="form-control chc-input-corto" value={valorUnico} onChange={(e) => this.handleChangeDefaultValueUnico(e.target.value)}/>
          </div>
        );
      case 'fecha':
        return (
          <div className="form-group">
            <label>Fecha predeterminada (opcional)</label>
            <input type="date" className="form-control chc-input-corto" value={valorUnico} onChange={(e) => this.handleChangeDefaultValueUnico(e.target.value)}/>
          </div>
        );
      case 'fecha_hora':
        return (
          <div className="form-group">
            <label>Fecha y hora predeterminada (opcional)</label>
            <input type="datetime-local" className="form-control" value={valorUnico} onChange={(e) => this.handleChangeDefaultValueUnico(e.target.value)}/>
          </div>
        );
      case 'si_no':
        return (
          <div className="form-group">
            <label>Respuesta predeterminada (opcional)</label>
            <select className="form-control chc-input-corto" value={valorUnico} onChange={(e) => this.handleChangeDefaultValueUnico(e.target.value)}>
              <option value="">Sin definir</option>
              <option value="Sí">Sí</option>
              <option value="No">No</option>
            </select>
          </div>
        );
      case 'lista_desplegable':
      case 'opciones_botones':
        return (
          <div className="form-group">
            <label>Opción predeterminada (opcional)</label>
            <select className="form-control" value={valorUnico} onChange={(e) => this.handleChangeDefaultValueUnico(e.target.value)}>
              <option value="">Sin definir</option>
              {campoActual.options.map((o, i) => <option key={i} value={o.value}>{o.name}</option>)}
            </select>
          </div>
        );
      case 'lista_multiple':
        return (
          <div className="form-group">
            <label>Opciones predeterminadas (opcional)</label>
            <div className="chc-prueba-opciones">
              {campoActual.options.length ? campoActual.options.map((o, i) => (
                <label className="chc-prueba-opcion" key={i}>
                  <input type="checkbox" checked={(campoActual.defaultValue || []).includes(o.value)} onChange={() => this.handleToggleDefaultValueMultiple(o.value)}/> {o.name}
                </label>
              )) : <span className="chc-chips__vacio">Agrega primero las opciones de este campo</span>}
            </div>
          </div>
        );
      case 'catalogo':
        return (
          <div className="form-group">
            <label>Valor{campoActual.multiSelect ? 'es' : ''} predeterminado{campoActual.multiSelect ? 's' : ''} (opcional)</label>
            <input type="text" className="form-control" placeholder={campoActual.multiSelect ? 'Códigos separados por coma' : 'Código del catálogo'} value={(campoActual.defaultValue || []).join(', ')} onChange={(e) => this.handleChangeDefaultValueCatalogo(e.target.value)}/>
            <small className="form-text text-muted">El catálogo real no está disponible acá: escribe directamente el código que quieres dejar predeterminado.</small>
          </div>
        );
      default:
        return null;
    }
  };

  agregarOpcion = () => {
    const nombre = this.state.opcionNueva.trim();
    if(!nombre) return;
    const valor = this.state.valorOpcionNueva.trim() || generarCodigo(nombre);
    this.setState((prevState) => ({
      campoActual: {
        ...prevState.campoActual,
        options: [...prevState.campoActual.options, { name: nombre, value: valor }]
      },
      opcionNueva: '',
      valorOpcionNueva: ''
    }));
  };

  quitarOpcion = (indice) => {
    this.setState((prevState) => ({
      campoActual: {
        ...prevState.campoActual,
        options: prevState.campoActual.options.filter((_, i) => i!==indice)
      }
    }));
  };

  handleChangeColumnaNueva = (propiedad, valor) => {
    this.setState((prevState) => ({
      columnaNueva: { ...prevState.columnaNueva, [propiedad]: valor }
    }));
  };

  agregarOpcionColumnaNueva = () => {
    const nombre = this.state.opcionColumnaNueva.trim();
    if(!nombre) return;
    const valor = this.state.valorOpcionColumnaNueva.trim() || generarCodigo(nombre);
    this.setState((prevState) => ({
      columnaNueva: {
        ...prevState.columnaNueva,
        options: [...prevState.columnaNueva.options, { name: nombre, value: valor }]
      },
      opcionColumnaNueva: '',
      valorOpcionColumnaNueva: ''
    }));
  };

  quitarOpcionColumnaNueva = (indice) => {
    this.setState((prevState) => ({
      columnaNueva: {
        ...prevState.columnaNueva,
        options: prevState.columnaNueva.options.filter((_, i) => i!==indice)
      }
    }));
  };

  agregarColumna = () => {
    const { columnaNueva } = this.state;
    const nombre = columnaNueva.label.trim();
    if(!nombre){
      store.addNotification(notifAtencion("Escribe el nombre de la columna."));
      return;
    }
    if(columnaNueva.tipoColumna==='lista' && columnaNueva.options.length===0){
      store.addNotification(notifAtencion("Agrega al menos una opción para la columna."));
      return;
    }
    if(columnaNueva.tipoColumna==='lista_catalogo' && !columnaNueva.catalog){
      store.addNotification(notifAtencion("Selecciona el catálogo para la columna."));
      return;
    }

    this.setState((prevState) => ({
      campoActual: {
        ...prevState.campoActual,
        columns: [...prevState.campoActual.columns, { ...columnaNueva, label: nombre, code: generarCodigo(nombre) }]
      },
      columnaNueva: columnaVacia(),
      opcionColumnaNueva: ''
    }));
  };

  quitarColumna = (indice) => {
    this.setState((prevState) => ({
      campoActual: {
        ...prevState.campoActual,
        columns: prevState.campoActual.columns.filter((_, i) => i!==indice)
      }
    }));
  };

  limpiarCampoActual = () => {
    this.setState({ campoActual: campoVacio(), indiceEditando: null, mostrarAvanzado: false });
  };

  guardarCampoEnLista = () => {
    const { campoActual, indiceEditando } = this.state;

    if(!campoActual.tipoCampo){
      store.addNotification(notifAtencion("Selecciona un tipo de campo."));
      return;
    }
    if(!campoActual.label.trim()){
      store.addNotification(notifAtencion("Escribe el nombre visible del campo."));
      return;
    }
    if((campoActual.tipoCampo==='lista_desplegable' || campoActual.tipoCampo==='lista_multiple' || campoActual.tipoCampo==='opciones_botones') && campoActual.options.length===0){
      store.addNotification(notifAtencion("Agrega al menos una opción."));
      return;
    }
    if(campoActual.tipoCampo==='catalogo' && !campoActual.catalog.trim()){
      store.addNotification(notifAtencion("Indica el catálogo que va a usar este campo."));
      return;
    }
    if(campoActual.tipoCampo==='tabla' && campoActual.columns.length===0){
      store.addNotification(notifAtencion("Agrega al menos una columna a la tabla."));
      return;
    }

    const codigoFinal = campoActual.code.trim() || generarCodigo(campoActual.label);
    const yaExiste = this.state.campos.some((c, i) => c.code===codigoFinal && i!==indiceEditando);
    if(yaExiste){
      store.addNotification(notifAtencion("Ya existe un campo con ese código, cambia el nombre o el código interno."));
      return;
    }

    const campoFinal = { ...campoActual, code: codigoFinal };

    this.setState((prevState) => {
      const campos = [...prevState.campos];
      if(indiceEditando!==null){
        campos[indiceEditando] = campoFinal;
      }else{
        campos.push(campoFinal);
      }
      return { campos, campoActual: campoVacio(), indiceEditando: null, mostrarAvanzado: false };
    });
  };

  editarCampo = (indice) => {
    this.setState({ campoActual: { ...this.state.campos[indice] }, indiceEditando: indice, mostrarAvanzado: false });
  };

  eliminarCampo = (indice) => {
    if(this.state.campos[indice] && this.state.campos[indice].esNormativo){
      $('#modal-campo-normativo').modal('show');
      return;
    }

    this.setState((prevState) => ({
      campos: prevState.campos.filter((_, i) => i!==indice),
      indiceEditando: prevState.indiceEditando===indice ? null : prevState.indiceEditando,
      campoActual: prevState.indiceEditando===indice ? campoVacio() : prevState.campoActual
    }));
  };

  moverCampo = (indice, direccion) => {
    this.setState((prevState) => {
      const campos = [...prevState.campos];
      const nuevoIndice = indice + direccion;
      if(nuevoIndice<0 || nuevoIndice>=campos.length) return null;
      const temp = campos[indice];
      campos[indice] = campos[nuevoIndice];
      campos[nuevoIndice] = temp;
      return { campos };
    });
  };

  obtenerSeccionesUsadas = () => Array.from(new Set(this.state.campos.map((c) => c.section).filter(Boolean)));

  // Agrupa por RACHAS consecutivas de la misma sección (no por sección
  // única en toda la lista) para respetar el orden real de los campos: un
  // campo sin sección no debe "saltar" a juntarse con otro campo sin
  // sección que esté lejos en la lista, solo porque ambos comparten la
  // misma clave "sin sección".
  agruparPorSeccion = () => {
    const grupos = [];
    this.state.campos.forEach((campo) => {
      const clave = campo.section || '__sin_seccion__';
      const ultimoGrupo = grupos[grupos.length - 1];
      if(ultimoGrupo && ultimoGrupo[0]===clave){
        ultimoGrupo[1].push(campo);
      }else{
        grupos.push([clave, [campo]]);
      }
    });
    return grupos;
  };

  // Arma cada historyField incluyendo solo las llaves que aplican a ese campo
  // (igual que la configuración de ejemplo que sí guardó: los campos de
  // texto no traen "control" ni "options", por ejemplo), usando el
  // vocabulario real confirmado (type en español, "calculado"/"decimales"
  // en vez de "calculated"/"decimals"). El ancho de columna sí se guarda en
  // inglés ("width"): el backend lo devuelve como "width": null cuando se
  // envía como "ancho".
  construirHistoryField = (c) => {
    const campo = {
      code: c.code,
      label: c.label,
      type: c.type,
      required: !!c.required,
      section: c.section || ''
    };

    if(c.control) campo.control = c.control;
    campo.width = Number(c.width) || 12;
    if(c.multiline) campo.multiline = true;
    if(c.withTime) campo.withTime = true;
    if(c.multiSelect) campo.multiSelect = true;
    if(c.options && c.options.length) campo.options = c.options;
    if(c.catalog) campo.catalog = c.catalog;
    if(Number(c.maxLength)) campo.maxLength = Number(c.maxLength);
    if(Number(c.max)) campo.max = Number(c.max);
    if(c.tipoCampo==='calculado' && c.calculated){
      campo.calculado = c.calculated;
      campo.decimales = Number(c.decimals) || 0;
    }
    if(c.visibleIf && c.visibleIf.fieldCode) campo.visibleIf = c.visibleIf;
    if(c.visibleForSex && c.visibleForSex.length) campo.visibleForSex = c.visibleForSex;
    if(c.antecedent) campo.antecedent = true;
    if(c.tipoCampo==='tabla' && c.columns && c.columns.length){
      campo.columns = c.columns.map((col) => this.construirColumnaTabla(col));
    }
    if(c.defaultValue && c.defaultValue.length) campo.defaultValue = c.defaultValue;

    return campo;
  };

  construirColumnaTabla = (col) => {
    const tipoAlDato = { texto:'texto', numero:'numero', lista:'lista', lista_catalogo:'lista' };
    const columna = {
      code: col.code || generarCodigo(col.label),
      label: col.label,
      type: tipoAlDato[col.tipoColumna] || 'texto'
    };
    if(col.tipoColumna==='lista'){
      columna.control = 'desplegable';
      if(col.options && col.options.length) columna.options = col.options;
    }
    if(col.tipoColumna==='lista_catalogo'){
      columna.control = 'desplegable';
      if(col.catalog) columna.catalog = col.catalog;
    }
    if(Number(col.maxLength)) columna.maxLength = Number(col.maxLength);
    return columna;
  };

  construirPayload = () => {
    const { nombre, specialtyId, requirePrescription, requireOrder, requireIncapacity, isControl, campos } = this.state;
    return {
      name: nombre,
      specialtyId: Number(specialtyId) || 0,
      requirePrescription,
      requireOrder,
      requireIncapacity,
      isControl,
      historyFields: campos.map((c) => this.construirHistoryField(c))
    };
  };

  guardarHistoriaClinica = () => {
    const { nombre, specialtyId, campos } = this.state;

    if(!nombre.trim()){
      store.addNotification(notifAtencion("Escribe un nombre para esta historia clínica."));
      return;
    }
    if(!specialtyId){
      store.addNotification(notifAtencion("Selecciona la especialidad."));
      return;
    }
    if(campos.length===0){
      store.addNotification(notifAtencion("Agrega al menos un campo a la historia clínica."));
      return;
    }

    this.setState({ guardando:true });

    const { idHistoriaEditando } = this.state;
    const peticion = idHistoriaEditando
      ? axios.put(ApiURL + "/api/ConfigClinicalHistory/" + idHistoriaEditando, this.construirPayload())
      : axios.post(ApiURL + "/api/ConfigClinicalHistory/Create", this.construirPayload());

    peticion
    .then((response) => {
      console.log(response);

      if(idHistoriaEditando){
        store.addNotification(notifExito("Historia clínica actualizada correctamente"));
        window.location.href = "/historias_clinicas_configuradas";
        return;
      }

      store.addNotification(notifExito("Historia clínica creada correctamente"));
      this.setState({
        guardando:false,
        nombre:'',
        specialtyId:'',
        requirePrescription:false,
        requireOrder:false,
        requireIncapacity:false,
        isControl:false,
        campos:[],
        campoActual: campoVacio(),
        indiceEditando:null
      });
    })
    .catch((error) => {
      console.log(error);
      const mensaje = (error.response && error.response.data && error.response.data.message) || (idHistoriaEditando ? "No se pudo actualizar la historia clínica" : "No se pudo crear la historia clínica");
      store.addNotification(notifAtencion(mensaje));
      this.setState({ guardando:false });
    });
  };

  /**
   * "Modo prueba": abre un modal con la historia clínica renderizada con
   * campos de verdad (interactivos), no los de la vista previa (que son de
   * solo lectura). Es puramente visual — nada de lo que se escriba aquí se
   * guarda ni se envía a ningún lado.
   */
  abrirModoPrueba = () => {
    // El modo prueba arranca con el "Valor predeterminado" ya puesto en cada
    // campo que lo tenga configurado, igual que se vería al diligenciar una
    // historia clínica real.
    const valoresIniciales = {};
    this.state.campos.forEach((campo) => {
      const dv = campo.defaultValue;
      if(!dv || dv.length===0) return;
      if(campo.tipoCampo==='si_no'){
        valoresIniciales[campo.code] = dv[0]==='Sí';
      }else if(campo.tipoCampo==='lista_multiple' || (campo.tipoCampo==='catalogo' && campo.multiSelect)){
        valoresIniciales[campo.code] = dv;
      }else{
        valoresIniciales[campo.code] = dv[0];
      }
    });

    this.setState({ valoresPrueba:valoresIniciales, filasTablaPrueba:{}, sexoPrueba:'' }, () => {
      $('#modal-probar-historia').modal('show');
    });
  };

  handleChangeValorPrueba = (code, valor) => {
    this.setState((prevState) => ({
      valoresPrueba: { ...prevState.valoresPrueba, [code]: valor }
    }));
  };

  handleToggleValorMultiplePrueba = (code, valor) => {
    this.setState((prevState) => {
      const actuales = prevState.valoresPrueba[code] || [];
      const nuevos = actuales.includes(valor) ? actuales.filter((v) => v!==valor) : [...actuales, valor];
      return { valoresPrueba: { ...prevState.valoresPrueba, [code]: nuevos } };
    });
  };

  agregarFilaTablaPrueba = (code) => {
    this.setState((prevState) => {
      const filas = prevState.filasTablaPrueba[code] || [];
      return { filasTablaPrueba: { ...prevState.filasTablaPrueba, [code]: [...filas, {}] } };
    });
  };

  quitarFilaTablaPrueba = (code, indiceFila) => {
    this.setState((prevState) => {
      const filas = prevState.filasTablaPrueba[code] || [];
      return { filasTablaPrueba: { ...prevState.filasTablaPrueba, [code]: filas.filter((_, i) => i!==indiceFila) } };
    });
  };

  handleChangeCeldaTablaPrueba = (code, indiceFila, colCode, valor) => {
    this.setState((prevState) => {
      const filas = [...(prevState.filasTablaPrueba[code] || [])];
      filas[indiceFila] = { ...filas[indiceFila], [colCode]: valor };
      return { filasTablaPrueba: { ...prevState.filasTablaPrueba, [code]: filas } };
    });
  };

  // Un campo se oculta en el modo prueba si depende de otro campo
  // (visibleIf) que todavía no tiene esa respuesta, o si está restringido a
  // un sexo distinto al elegido arriba (visibleForSex).
  campoEsVisibleEnPrueba = (campo) => {
    const { valoresPrueba, sexoPrueba, campos } = this.state;

    if(campo.visibleIf && campo.visibleIf.fieldCode){
      const campoOrigen = campos.find((c) => c.code===campo.visibleIf.fieldCode);
      let valorActual = valoresPrueba[campo.visibleIf.fieldCode];
      // Los campos Sí/No guardan un booleano en valoresPrueba, pero
      // visibleIf.equalTo compara contra el texto "Sí"/"No" (así viene en
      // la configuración real), así que hay que traducirlo antes de comparar.
      if(campoOrigen && campoOrigen.tipoCampo==='si_no'){
        valorActual = valorActual ? 'Sí' : 'No';
      }
      if(String(valorActual || '')!==String(campo.visibleIf.equalTo)) return false;
    }
    if(campo.visibleForSex && campo.visibleForSex.length && sexoPrueba){
      if(!campo.visibleForSex.includes(sexoPrueba)) return false;
    }
    return true;
  };

  renderCampoPrueba = (campo) => {
    const valor = this.state.valoresPrueba[campo.code];
    const etiqueta = (
      <label className="chc-preview__campo-label">
        {campo.label}
        {campo.required ? <span className="chc-campo-item__requerido"> *</span> : null}
      </label>
    );

    switch(campo.tipoCampo){
      case 'texto_corto':
        return <div className="form-group">{etiqueta}<input type="text" className="form-control" maxLength={Number(campo.maxLength) || undefined} value={valor || ''} onChange={(e) => this.handleChangeValorPrueba(campo.code, e.target.value)}/></div>;
      case 'texto_largo':
        return <div className="form-group">{etiqueta}<textarea className="form-control" rows="3" maxLength={Number(campo.maxLength) || undefined} value={valor || ''} onChange={(e) => this.handleChangeValorPrueba(campo.code, e.target.value)}></textarea></div>;
      case 'numero':
        return <div className="form-group">{etiqueta}<input type="number" className="form-control" max={Number(campo.max) || undefined} step={Number(campo.decimals) > 0 ? (1 / Math.pow(10, Number(campo.decimals))) : 1} value={valor || ''} onChange={(e) => this.handleChangeValorPrueba(campo.code, e.target.value)}/></div>;
      case 'fecha':
        return <div className="form-group">{etiqueta}<input type="date" className="form-control" value={valor || ''} onChange={(e) => this.handleChangeValorPrueba(campo.code, e.target.value)}/></div>;
      case 'fecha_hora':
        return <div className="form-group">{etiqueta}<input type="datetime-local" className="form-control" value={valor || ''} onChange={(e) => this.handleChangeValorPrueba(campo.code, e.target.value)}/></div>;
      case 'si_no':
        return (
          <div className="form-group">
            {etiqueta}
            <div>
              <label className="chc-switch">
                <input type="checkbox" checked={!!valor} onChange={(e) => this.handleChangeValorPrueba(campo.code, e.target.checked)}/>
                <span className="chc-switch__control"></span>
              </label>
            </div>
          </div>
        );
      case 'lista_desplegable':
        return (
          <div className="form-group">
            {etiqueta}
            <select className="form-control" value={valor || ''} onChange={(e) => this.handleChangeValorPrueba(campo.code, e.target.value)}>
              <option value="">Seleccione...</option>
              {campo.options.map((o, i) => <option key={i} value={o.value}>{o.name}</option>)}
            </select>
          </div>
        );
      case 'lista_multiple':
        return (
          <div className="form-group">
            {etiqueta}
            <div className="chc-prueba-opciones">
              {campo.options.map((o, i) => (
                <label className="chc-prueba-opcion" key={i}>
                  <input type="checkbox" checked={(valor || []).includes(o.value)} onChange={() => this.handleToggleValorMultiplePrueba(campo.code, o.value)}/> {o.name}
                </label>
              ))}
            </div>
          </div>
        );
      case 'opciones_botones':
        return (
          <div className="form-group">
            {etiqueta}
            <div className="chc-preview__botones">
              {campo.options.length ? campo.options.map((o, i) => (
                <span className={"chc-preview__boton chc-preview__boton--clic" + (valor===o.value ? ' chc-preview__boton--activo' : '')} key={i} onClick={() => this.handleChangeValorPrueba(campo.code, o.value)}>{o.name}</span>
              )) : <span className="chc-preview__boton chc-preview__boton--vacio">Sin opciones</span>}
            </div>
          </div>
        );
      case 'catalogo': {
        const datosCatalogo = DATOS_CATALOGO_PRUEBA[campo.catalog] || [];
        if(campo.multiSelect){
          return (
            <div className="form-group">
              {etiqueta}
              <div className="chc-prueba-opciones">
                {datosCatalogo.length ? datosCatalogo.map((o, i) => (
                  <label className="chc-prueba-opcion" key={i}>
                    <input type="checkbox" checked={(valor || []).includes(o.value)} onChange={() => this.handleToggleValorMultiplePrueba(campo.code, o.value)}/> {o.name}
                  </label>
                )) : <span className="chc-chips__vacio">Sin datos de ejemplo para "{campo.catalog}"</span>}
              </div>
              <small className="form-text text-muted">Datos de ejemplo del catálogo "{campo.catalog}", solo para esta prueba.</small>
            </div>
          );
        }
        return (
          <div className="form-group">
            {etiqueta}
            <select className="form-control" value={valor || ''} onChange={(e) => this.handleChangeValorPrueba(campo.code, e.target.value)}>
              <option value="">Seleccione...</option>
              {datosCatalogo.map((o, i) => <option key={i} value={o.value}>{o.name}</option>)}
            </select>
            <small className="form-text text-muted">Datos de ejemplo del catálogo "{campo.catalog}", solo para esta prueba.</small>
          </div>
        );
      }
      case 'tabla': {
        const filas = this.state.filasTablaPrueba[campo.code] || [];
        return (
          <div className="form-group">
            {etiqueta}
            <div className="chc-preview__tabla-wrap">
              <table className="table table-bordered table-sm chc-preview__tabla">
                <thead>
                  <tr>
                    {campo.columns.length ? campo.columns.map((col, i) => <th key={i}>{col.label}</th>) : <th>Sin columnas</th>}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {filas.map((fila, indiceFila) => (
                    <tr key={indiceFila}>
                      {campo.columns.map((col, indiceCol) => (
                        <td key={indiceCol}>
                          {col.tipoColumna==='numero' ? (
                            <input type="number" className="form-control form-control-sm" value={fila[col.code] || ''} onChange={(e) => this.handleChangeCeldaTablaPrueba(campo.code, indiceFila, col.code, e.target.value)}/>
                          ) : (col.tipoColumna==='lista') ? (
                            <select className="form-control form-control-sm" value={fila[col.code] || ''} onChange={(e) => this.handleChangeCeldaTablaPrueba(campo.code, indiceFila, col.code, e.target.value)}>
                              <option value="">Seleccione...</option>
                              {col.options.map((o, i) => <option key={i} value={o.value}>{o.name}</option>)}
                            </select>
                          ) : (col.tipoColumna==='lista_catalogo') ? (
                            <select className="form-control form-control-sm" value={fila[col.code] || ''} onChange={(e) => this.handleChangeCeldaTablaPrueba(campo.code, indiceFila, col.code, e.target.value)}>
                              <option value="">Seleccione...</option>
                              {(DATOS_CATALOGO_PRUEBA[col.catalog] || []).map((o, i) => <option key={i} value={o.value}>{o.name}</option>)}
                            </select>
                          ) : (
                            <input type="text" className="form-control form-control-sm" value={fila[col.code] || ''} onChange={(e) => this.handleChangeCeldaTablaPrueba(campo.code, indiceFila, col.code, e.target.value)}/>
                          )}
                        </td>
                      ))}
                      <td className="text-center">
                        <i className="fas fa-trash-alt chc-prueba-tabla__quitar" onClick={() => this.quitarFilaTablaPrueba(campo.code, indiceFila)}></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button type="button" className="btn chc-btn-agregar" onClick={() => this.agregarFilaTablaPrueba(campo.code)}><i className="fas fa-plus"></i> Agregar fila</button>
            </div>
          </div>
        );
      }
      case 'calculado':
        return <div className="form-group">{etiqueta}<input type="text" className="form-control chc-preview__calculado" disabled placeholder="Se calcula automáticamente"/></div>;
      default:
        return null;
    }
  };

  renderVistaPreviaCampo = (campo) => {
    const etiqueta = (
      <label className="chc-preview__campo-label">
        {campo.label}
        {campo.required ? <span className="chc-campo-item__requerido"> *</span> : null}
      </label>
    );

    const valorPredeterminado = (campo.defaultValue && campo.defaultValue[0]) || '';

    switch(campo.tipoCampo){
      case 'texto_corto':
        return <div className="form-group">{etiqueta}<input type="text" className="form-control" disabled value={valorPredeterminado} placeholder="Texto corto"/></div>;
      case 'texto_largo':
        return <div className="form-group">{etiqueta}<textarea className="form-control" disabled rows="2" value={valorPredeterminado} placeholder="Texto largo"></textarea></div>;
      case 'numero':
        return <div className="form-group">{etiqueta}<input type="number" className="form-control" disabled value={valorPredeterminado} placeholder="0"/></div>;
      case 'fecha':
        return <div className="form-group">{etiqueta}<input type="date" className="form-control" disabled value={valorPredeterminado}/></div>;
      case 'fecha_hora':
        return <div className="form-group">{etiqueta}<input type="datetime-local" className="form-control" disabled value={valorPredeterminado}/></div>;
      case 'si_no':
        return (
          <div className="form-group">
            {etiqueta}
            <div>
              <label className="chc-switch chc-switch--preview">
                <input type="checkbox" disabled checked={valorPredeterminado==='Sí'}/>
                <span className="chc-switch__control"></span>
              </label>
            </div>
          </div>
        );
      case 'lista_desplegable':
      case 'lista_multiple':
        return (
          <div className="form-group">
            {etiqueta}
            <select className="form-control" disabled>
              <option>{campo.multiSelect ? '(selección múltiple)' : 'Seleccione...'}</option>
              {campo.options.map((o, i) => <option key={i}>{o.name}</option>)}
            </select>
          </div>
        );
      case 'opciones_botones':
        return (
          <div className="form-group">
            {etiqueta}
            <div className="chc-preview__botones">
              {campo.options.length ? campo.options.map((o, i) => <span className="chc-preview__boton" key={i}>{o.name}</span>) : <span className="chc-preview__boton chc-preview__boton--vacio">Sin opciones</span>}
            </div>
          </div>
        );
      case 'catalogo':
        return <div className="form-group">{etiqueta}<input type="text" className="form-control" disabled placeholder={"Buscar en " + (campo.catalog || 'catálogo') + "..."}/></div>;
      case 'tabla':
        return (
          <div className="form-group">
            {etiqueta}
            <div className="chc-preview__tabla-wrap">
              <table className="table table-bordered table-sm chc-preview__tabla">
                <thead>
                  <tr>{campo.columns.length ? campo.columns.map((c, i) => <th key={i}>{c.label}</th>) : <th>Sin columnas</th>}</tr>
                </thead>
                <tbody>
                  <tr>{(campo.columns.length ? campo.columns : ['']).map((c, i) => <td key={i}>&nbsp;</td>)}</tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      case 'calculado':
        return <div className="form-group">{etiqueta}<input type="text" className="form-control chc-preview__calculado" disabled placeholder="Se calcula automáticamente"/></div>;
      default:
        return null;
    }
  };

  render(){
    const { campoActual, idHistoriaEditando, cargandoHistoria } = this.state;
    const tipoInfoActual = TIPOS_CAMPO.find((t) => t.id===campoActual.tipoCampo);

    if(cargandoHistoria){
      return (
        <div className="content-wrapper">
          <div className="col-12 col-sm-12 d-flex justify-content-center" style={{padding:'60px 0'}}>
            <ReactBootStrap.Spinner animation="border" style={{color:'#AD1457'}}/>
          </div>
        </div>
      );
    }

    return (

      <div className="content-wrapper">

        <div className="col-12 col-sm-12">

          <div className="chc-header">
            {idHistoriaEditando ? (
              <button type="button" className="chc-btn-atras" onClick={() => window.location.href = "/historias_clinicas_configuradas"}>
                <i className="fas fa-arrow-left"></i> Atrás
              </button>
            ) : null}
            <div className="chc-header__icono"><i className="fas fa-file-medical-alt"></i></div>
            <div className="chc-header__texto">
              <h1 className="chc-header__titulo">{idHistoriaEditando ? 'Editar historia clínica' : 'Crear historia clínica'}</h1>
              <p className="chc-header__subtitulo">{idHistoriaEditando ? 'Ajusta los datos generales y los campos de esta historia clínica. A la derecha puedes ver cómo va quedando.' : 'Arma el formulario que van a diligenciar tus profesionales, agregando y organizando los campos que necesites. A la derecha puedes ver cómo va quedando.'}</p>
            </div>
          </div>

          <div className="row chc-layout">

            <div className="col-lg-7">

              <div className="card chc-card">
                <div className="card-body">
                  <h6 className="chc-card__titulo"><i className="fas fa-info-circle"></i> Datos generales</h6>

                  <div className="row">
                    <div className="col-md-7">
                      <div className="form-group">
                        <label>Nombre de la historia clínica</label>
                        <input type="text" className="form-control" placeholder="Ej: Consulta de medicina general" value={this.state.nombre} onChange={this.handleChangeNombre}/>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="form-group">
                        <label>Especialidad</label>
                        <select className="form-control" value={this.state.specialtyId} onChange={this.handleChangeSpecialty}>
                          <option value="">Seleccione...</option>
                          {this.state.especialidades.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row chc-switches">
                    <div className="col-md-3">
                      <label className="chc-switch">
                        <input type="checkbox" checked={this.state.requirePrescription} onChange={() => this.handleToggleEncabezado('requirePrescription')}/>
                        <span className="chc-switch__control"></span>
                        <span className="chc-switch__texto">Requiere fórmula médica</span>
                      </label>
                    </div>
                    <div className="col-md-3">
                      <label className="chc-switch">
                        <input type="checkbox" checked={this.state.requireOrder} onChange={() => this.handleToggleEncabezado('requireOrder')}/>
                        <span className="chc-switch__control"></span>
                        <span className="chc-switch__texto">Requiere orden médica</span>
                      </label>
                    </div>
                    <div className="col-md-3">
                      <label className="chc-switch">
                        <input type="checkbox" checked={this.state.requireIncapacity} onChange={() => this.handleToggleEncabezado('requireIncapacity')}/>
                        <span className="chc-switch__control"></span>
                        <span className="chc-switch__texto">Requiere incapacidad</span>
                      </label>
                    </div>
                    <div className="col-md-3">
                      <label className="chc-switch">
                        <input type="checkbox" checked={this.state.isControl} onChange={() => this.handleToggleEncabezado('isControl')}/>
                        <span className="chc-switch__control"></span>
                        <span className="chc-switch__texto">Es consulta de control</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card chc-card">
                <div className="card-body">
                  <h6 className="chc-card__titulo"><i className="fas fa-shapes"></i> {this.state.indiceEditando!==null ? 'Editar campo' : 'Agregar un campo'}</h6>

                  <div className="chc-tipos-grid">
                    {TIPOS_CAMPO.map((t) => (
                      <button type="button" key={t.id} className={"chc-tipo-card" + (campoActual.tipoCampo===t.id ? ' chc-tipo-card--activo' : '')} onClick={() => this.seleccionarTipoCampo(t.id)} title={t.ayuda}>
                        <i className={"fas " + t.icono}></i>
                        <span>{t.etiqueta}</span>
                      </button>
                    ))}
                  </div>

                  {campoActual.tipoCampo ? (
                    <div className="chc-config-campo">

                      <p className="chc-config-campo__ayuda"><i className="fas fa-lightbulb"></i> {tipoInfoActual ? tipoInfoActual.ayuda : ''}</p>

                      <div className="row">
                        <div className="col-md-8">
                          <div className="form-group">
                            <label>Nombre visible del campo</label>
                            <input type="text" className="form-control" placeholder="Ej: Motivo de consulta" value={campoActual.label} onChange={(e) => this.handleChangeCampo('label', e.target.value)}/>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>&nbsp;</label>
                            <label className="chc-switch">
                              <input type="checkbox" checked={campoActual.required} onChange={(e) => this.handleChangeCampo('required', e.target.checked)}/>
                              <span className="chc-switch__control"></span>
                              <span className="chc-switch__texto">Campo obligatorio</span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Sección de la historia clínica</label>
                            <input type="text" list="chc-secciones" className="form-control" placeholder="Ej: Antecedentes, Examen físico..." value={campoActual.section} onChange={(e) => this.handleChangeCampo('section', e.target.value)}/>
                            <datalist id="chc-secciones">
                              {this.obtenerSeccionesUsadas().map((s) => <option key={s} value={s}/>)}
                            </datalist>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Ancho del campo</label>
                            <div className="chc-anchos">
                              {ANCHOS.map((a) => (
                                <button type="button" key={a.valor} className={"chc-ancho-btn" + (Number(campoActual.width)===a.valor ? ' chc-ancho-btn--activo' : '')} onClick={() => this.handleChangeCampo('width', a.valor)} title={a.ayuda}>{a.etiqueta}</button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      {(campoActual.tipoCampo==='texto_corto' || campoActual.tipoCampo==='texto_largo') ? (
                        <div className="form-group">
                          <label>Límite de caracteres (opcional)</label>
                          <input type="number" min="0" className="form-control chc-input-corto" placeholder="Sin límite" value={campoActual.maxLength} onChange={(e) => this.handleChangeCampo('maxLength', e.target.value)}/>
                        </div>
                      ) : null}

                      {campoActual.tipoCampo==='numero' ? (
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>¿Permite decimales?</label>
                              <select className="form-control" value={campoActual.decimals} onChange={(e) => this.handleChangeCampo('decimals', e.target.value)}>
                                <option value="0">No, solo números enteros</option>
                                <option value="1">Sí, con 1 decimal</option>
                                <option value="2">Sí, con 2 decimales</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Valor máximo permitido (opcional)</label>
                              <input type="number" className="form-control" placeholder="Sin límite" value={campoActual.max} onChange={(e) => this.handleChangeCampo('max', e.target.value)}/>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {(campoActual.tipoCampo==='lista_desplegable' || campoActual.tipoCampo==='lista_multiple' || campoActual.tipoCampo==='opciones_botones') ? (
                        <div className="form-group">
                          <label>Opciones para elegir</label>
                          <div className="chc-agregar-item">
                            <input type="text" className="form-control" placeholder="Nombre visible. Ej: Leve" value={this.state.opcionNueva} onChange={(e) => this.setState({ opcionNueva:e.target.value })} onKeyDown={(e) => { if(e.key==='Enter'){ e.preventDefault(); this.agregarOpcion(); } }}/>
                            <input type="text" className="form-control chc-input-valor" placeholder="Valor (opcional)" value={this.state.valorOpcionNueva} onChange={(e) => this.setState({ valorOpcionNueva:e.target.value })} onKeyDown={(e) => { if(e.key==='Enter'){ e.preventDefault(); this.agregarOpcion(); } }}/>
                            <button type="button" className="btn chc-btn-agregar" onClick={this.agregarOpcion}><i className="fas fa-plus"></i> Agregar</button>
                          </div>
                          <small className="form-text text-muted">El valor es el código que se guarda; si lo dejas vacío, se genera automáticamente a partir del nombre.</small>
                          <div className="chc-chips">
                            {campoActual.options.map((o, i) => (
                              <span className="chc-chip" key={i}>{o.name} <i className="fas fa-times" onClick={() => this.quitarOpcion(i)}></i></span>
                            ))}
                            {campoActual.options.length===0 ? <span className="chc-chips__vacio">Aún no has agregado opciones</span> : null}
                          </div>
                        </div>
                      ) : null}

                      {campoActual.tipoCampo==='catalogo' ? (
                        <div className="form-group">
                          <label>Catálogo que va a usar este campo</label>
                          <select className="form-control" value={campoActual.catalog} onChange={(e) => this.handleChangeCampo('catalog', e.target.value)}>
                            <option value="">Seleccione un catálogo...</option>
                            {CATALOGOS_SUGERIDOS.map((c) => <option key={c.value} value={c.value}>{c.name}</option>)}
                          </select>
                          <label className="chc-switch chc-switch--espaciado">
                            <input type="checkbox" checked={campoActual.multiSelect} onChange={(e) => this.handleChangeCampo('multiSelect', e.target.checked)}/>
                            <span className="chc-switch__control"></span>
                            <span className="chc-switch__texto">Permite elegir varias opciones del catálogo</span>
                          </label>
                        </div>
                      ) : null}

                      {campoActual.tipoCampo==='tabla' ? (
                        <div className="form-group">
                          <label>Columnas de la tabla</label>

                          <div className="chc-columna-editor">
                            <div className="row">
                              <div className="col-md-7">
                                <input type="text" className="form-control" placeholder="Nombre de la columna. Ej: Medicamento" value={this.state.columnaNueva.label} onChange={(e) => this.handleChangeColumnaNueva('label', e.target.value)}/>
                              </div>
                              <div className="col-md-5">
                                <select className="form-control" value={this.state.columnaNueva.tipoColumna} onChange={(e) => this.handleChangeColumnaNueva('tipoColumna', e.target.value)}>
                                  <option value="texto">Texto</option>
                                  <option value="numero">Número</option>
                                  <option value="lista">Lista desplegable</option>
                                  <option value="lista_catalogo">Lista desplegable con catálogo</option>
                                </select>
                              </div>
                            </div>

                            {this.state.columnaNueva.tipoColumna==='lista' ? (
                              <div className="chc-columna-editor__opciones">
                                <div className="chc-agregar-item">
                                  <input type="text" className="form-control" placeholder="Nombre visible. Ej: Leve" value={this.state.opcionColumnaNueva} onChange={(e) => this.setState({ opcionColumnaNueva:e.target.value })} onKeyDown={(e) => { if(e.key==='Enter'){ e.preventDefault(); this.agregarOpcionColumnaNueva(); } }}/>
                                  <input type="text" className="form-control chc-input-valor" placeholder="Valor (opcional)" value={this.state.valorOpcionColumnaNueva} onChange={(e) => this.setState({ valorOpcionColumnaNueva:e.target.value })} onKeyDown={(e) => { if(e.key==='Enter'){ e.preventDefault(); this.agregarOpcionColumnaNueva(); } }}/>
                                  <button type="button" className="btn chc-btn-agregar" onClick={this.agregarOpcionColumnaNueva}><i className="fas fa-plus"></i> Agregar</button>
                                </div>
                                <small className="form-text text-muted">El valor es el código que se guarda; si lo dejas vacío, se genera automáticamente a partir del nombre.</small>
                                <div className="chc-chips">
                                  {this.state.columnaNueva.options.map((o, i) => (
                                    <span className="chc-chip" key={i}>{o.name} <i className="fas fa-times" onClick={() => this.quitarOpcionColumnaNueva(i)}></i></span>
                                  ))}
                                  {this.state.columnaNueva.options.length===0 ? <span className="chc-chips__vacio">Aún no has agregado opciones</span> : null}
                                </div>
                              </div>
                            ) : null}

                            {this.state.columnaNueva.tipoColumna==='lista_catalogo' ? (
                              <div className="chc-columna-editor__opciones">
                                <select className="form-control" value={this.state.columnaNueva.catalog} onChange={(e) => this.handleChangeColumnaNueva('catalog', e.target.value)}>
                                  <option value="">Seleccione un catálogo...</option>
                                  {CATALOGOS_SUGERIDOS.map((c) => <option key={c.value} value={c.value}>{c.name}</option>)}
                                </select>
                              </div>
                            ) : null}

                            <button type="button" className="btn chc-btn-agregar chc-btn-agregar-columna" onClick={this.agregarColumna}><i className="fas fa-plus"></i> Agregar columna</button>
                          </div>

                          <div className="chc-chips chc-chips--columnas">
                            {campoActual.columns.map((c, i) => (
                              <span className="chc-chip" key={i}>{c.label} <small>({ETIQUETAS_TIPO_COLUMNA[c.tipoColumna] || 'texto'})</small> <i className="fas fa-times" onClick={() => this.quitarColumna(i)}></i></span>
                            ))}
                            {campoActual.columns.length===0 ? <span className="chc-chips__vacio">Aún no has agregado columnas</span> : null}
                          </div>
                        </div>
                      ) : null}

                      {campoActual.tipoCampo==='calculado' ? (
                        <div className="form-group">
                          <label>¿Cómo se calcula este valor?</label>
                          <input type="text" className="form-control" placeholder="Ej: Peso (kg) / Talla (m) al cuadrado = IMC" value={campoActual.calculated} onChange={(e) => this.handleChangeCampo('calculated', e.target.value)}/>
                          <small className="form-text text-muted">Describe la fórmula; tu equipo técnico la configurará en el sistema.</small>
                        </div>
                      ) : null}

                      {this.renderValorPredeterminado()}

                      <button type="button" className="chc-btn-avanzado" onClick={() => this.setState({ mostrarAvanzado: !this.state.mostrarAvanzado })}>
                        <i className={"fas " + (this.state.mostrarAvanzado ? 'fa-chevron-up' : 'fa-chevron-down')}></i> Opciones avanzadas (opcional)
                      </button>

                      {this.state.mostrarAvanzado ? (
                        <div className="chc-avanzado">

                          <div className="form-group">
                            <label className="chc-switch">
                              <input type="checkbox" checked={campoActual.antecedent} onChange={(e) => this.handleChangeCampo('antecedent', e.target.checked)}/>
                              <span className="chc-switch__control"></span>
                              <span className="chc-switch__texto">Es un antecedente del paciente (se recordará en futuras consultas)</span>
                            </label>
                          </div>

                          <div className="form-group">
                            <label>Visible solo para</label>
                            <div className="chc-radio-inline">
                              <label><input type="checkbox" checked={campoActual.visibleForSex.includes('F')} onChange={() => this.handleToggleSexo('F')}/> <i className="fas fa-venus"></i> Mujeres</label>
                              <label><input type="checkbox" checked={campoActual.visibleForSex.includes('M')} onChange={() => this.handleToggleSexo('M')}/> <i className="fas fa-mars"></i> Hombres</label>
                            </div>
                            <small className="form-text text-muted">Si no marcas ninguno, el campo será visible para todos los pacientes.</small>
                          </div>

                          {this.state.campos.length>0 ? (
                            <div className="form-group">
                              <label>Mostrar este campo solo si...</label>
                              <div className="row">
                                <div className="col-md-6">
                                  <select className="form-control" value={campoActual.visibleIf.fieldCode} onChange={(e) => this.handleChangeVisibleIf('fieldCode', e.target.value)}>
                                    <option value="">(No depende de otro campo)</option>
                                    {this.state.campos.map((c, i) => <option key={i} value={c.code}>{c.label}</option>)}
                                  </select>
                                </div>
                                <div className="col-md-6">
                                  <input type="text" className="form-control" placeholder="es igual a..." disabled={!campoActual.visibleIf.fieldCode} value={campoActual.visibleIf.equalTo} onChange={(e) => this.handleChangeVisibleIf('equalTo', e.target.value)}/>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="form-group">
                            <label>Código interno</label>
                            <input type="text" className="form-control chc-input-codigo" value={campoActual.code} onChange={(e) => this.handleChangeCampo('code', generarCodigo(e.target.value))}/>
                            <small className="form-text text-muted">Se genera automáticamente a partir del nombre; solo cámbialo si sabes lo que haces.</small>
                          </div>

                        </div>
                      ) : null}

                      <div className="chc-config-campo__acciones">
                        {this.state.indiceEditando!==null ? (
                          <button type="button" className="btn chc-btn-cancelar" onClick={this.limpiarCampoActual}>Cancelar edición</button>
                        ) : null}
                        <button type="button" className="btn chc-btn-guardar-campo" onClick={this.guardarCampoEnLista}>
                          <i className="fas fa-check"></i> {this.state.indiceEditando!==null ? 'Guardar cambios' : 'Agregar campo a la historia clínica'}
                        </button>
                      </div>

                    </div>
                  ) : null}

                </div>
              </div>

              <div className="card chc-card">
                <div className="card-body">
                  <div className="chc-card__header">
                    <h6 className="chc-card__titulo"><i className="fas fa-list-ul"></i> Campos agregados ({this.state.campos.length})</h6>
                    <button type="button" className="chc-btn-cargar-formato" onClick={this.abrirModalCargarPlantilla}>
                      <i className="fas fa-file-import"></i> Cargar formato
                    </button>
                  </div>

                  {this.state.campos.length===0 ? (
                    <p className="chc-vacio">Todavía no has agregado ningún campo.</p>
                  ) : (
                    <div className="chc-lista-campos">
                      {this.state.campos.map((campo, indice) => {
                        const tipoInfo = TIPOS_CAMPO.find((t) => t.id===campo.tipoCampo);
                        return (
                          <div className={"chc-campo-item" + (this.state.indiceEditando===indice ? ' chc-campo-item--editando' : '')} key={indice}>
                            <div className="chc-campo-item__icono"><i className={"fas " + (tipoInfo ? tipoInfo.icono : 'fa-question')}></i></div>
                            <div className="chc-campo-item__info">
                              <span className="chc-campo-item__label">{campo.label}{campo.required ? <span className="chc-campo-item__requerido"> *</span> : null}</span>
                              <span className="chc-campo-item__meta">{tipoInfo ? tipoInfo.etiqueta : ''}{campo.section ? ' · ' + campo.section : ''}</span>
                            </div>
                            <div className="chc-campo-item__acciones">
                              <button type="button" title="Subir" onClick={() => this.moverCampo(indice, -1)} disabled={indice===0}><i className="fas fa-arrow-up"></i></button>
                              <button type="button" title="Bajar" onClick={() => this.moverCampo(indice, 1)} disabled={indice===this.state.campos.length-1}><i className="fas fa-arrow-down"></i></button>
                              <button type="button" title="Editar" onClick={() => this.editarCampo(indice)}><i className="fas fa-pen"></i></button>
                              <button type="button" title="Eliminar" onClick={() => this.eliminarCampo(indice)}><i className="fas fa-trash-alt"></i></button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                </div>
              </div>

              <div className="chc-guardar-final">
                <button type="button" className="btn chc-btn-crear" disabled={this.state.guardando} onClick={this.guardarHistoriaClinica}>
                  {this.state.guardando ? <i className="fas fa-circle-notch fa-spin"></i> : <i className="fas fa-save"></i>}
                  {this.state.guardando ? (idHistoriaEditando ? ' Guardando...' : ' Creando...') : (idHistoriaEditando ? ' Guardar cambios' : ' Crear historia clínica')}
                </button>
              </div>

            </div>

            <div className="col-lg-5">
              <div className="chc-preview">
                <div className="chc-preview__header">
                  <div className="chc-preview__header-titulo"><i className="fas fa-eye"></i> <span>Vista previa</span></div>
                  <button type="button" className="btn chc-btn-probar" disabled={this.state.campos.length===0} onClick={this.abrirModoPrueba}>
                    <i className="fas fa-vial"></i> Probar
                  </button>
                </div>
                <div className="chc-preview__body">
                  <h5 className="chc-preview__nombre">{this.state.nombre || 'Nombre de la historia clínica'}</h5>

                  {this.state.campos.length===0 ? (
                    <p className="chc-preview__vacio">A medida que agregues campos, aquí verás cómo va quedando el formulario.</p>
                  ) : (
                    this.agruparPorSeccion().map(([seccion, camposSeccion], indiceGrupo) => (
                      <div className="chc-preview__seccion" key={seccion + '-' + indiceGrupo}>
                        {seccion!=='__sin_seccion__' ? <h6 className="chc-preview__seccion-titulo">{seccion}</h6> : null}
                        <div className="row">
                          {camposSeccion.map((campo, i) => (
                            <div className={"col-md-" + campo.width} key={i}>
                              {this.renderVistaPreviaCampo(campo)}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>

          </div>

        </div>

        <div className="modal fade" id="modal-cargar-plantilla" data-backdrop="static">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content chc-plantilla-modal">

              <div className="modal-header chc-plantilla-modal__header">
                <div className="chc-plantilla-modal__icono"><i className="fas fa-file-medical"></i></div>
                <h5 className="modal-title chc-plantilla-modal__title">Formato de historia clínica prediseñado</h5>
              </div>

              <div className="modal-body chc-plantilla-modal__body">
                <p>¿Desea cargar el formato de historia clínica que Medicall24 tiene prediseñado para sus prestadores?. De esta manera puede administrar los atributos que cada campo permite.</p>
                <b>Cabe resaltar que este formato contiene los campos mínimos normativos para el diligenciamiento de la historia clínica en Colombia.</b>

                {this.state.campos.length>0 ? (
                  <div className="chc-plantilla-modal__advertencia">
                    <i className="fas fa-exclamation-triangle"></i>
                    <span>Esto reemplazará los {this.state.campos.length} campo{this.state.campos.length===1 ? '' : 's'} que ya tienes agregados.</span>
                  </div>
                ) : null}
              </div>

              <div className="modal-footer chc-plantilla-modal__footer justify-content-between">
                <button type="button" className="btn chc-btn-cancelar" data-dismiss="modal">No</button>
                <button type="button" className="btn chc-btn-guardar-campo" onClick={this.cargarPlantillaMedicall24}>
                  <i className="fas fa-file-import"></i> Sí, cargar
                </button>
              </div>

            </div>
          </div>
        </div>

        <div className="modal fade" id="modal-campo-normativo" data-backdrop="static">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content chc-plantilla-modal">

              <div className="modal-header chc-plantilla-modal__header">
                <div className="chc-plantilla-modal__icono"><i className="fas fa-exclamation-triangle"></i></div>
                <h5 className="modal-title chc-plantilla-modal__title">No es posible eliminar este campo</h5>
              </div>

              <div className="modal-body chc-plantilla-modal__body">
                <p>Este campo es requerido por la normativa vigente para el diligenciamiento de la historia clínica y <b>no puede ser eliminado de la plantilla.</b> Puedes personalizarlo con los atributos que la configuración te permite.</p>
              </div>

              <div className="modal-footer chc-plantilla-modal__footer justify-content-end">
                <button type="button" className="btn chc-btn-guardar-campo" data-dismiss="modal">Entendido</button>
              </div>

            </div>
          </div>
        </div>

        <div className="modal fade" id="modal-probar-historia" data-backdrop="static">
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content chc-prueba-modal">

              <div className="modal-header chc-prueba-modal__header">
                <div className="chc-prueba-modal__icono"><i className="fas fa-vial"></i></div>
                <h5 className="modal-title chc-prueba-modal__title">Modo prueba: {this.state.nombre || 'Historia clínica'}</h5>
                <button type="button" className="close chc-prueba-modal__close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div className="modal-body chc-prueba-modal__body">

                <div className="chc-prueba-aviso">
                  <i className="fas fa-info-circle"></i>
                  <span>Esto es solo una simulación: nada de lo que escribas aquí se guarda. Sirve para ver cómo se comportan los campos que configuraste.</span>
                </div>

                <div className="form-group chc-prueba-sexo">
                  <label>Sexo del paciente (para probar campos que solo aplican a un sexo)</label>
                  <select className="form-control" value={this.state.sexoPrueba} onChange={(e) => this.setState({ sexoPrueba:e.target.value })}>
                    <option value="">Sin definir</option>
                    <option value="F">Femenino</option>
                    <option value="M">Masculino</option>
                  </select>
                </div>

                {this.agruparPorSeccion().map(([seccion, camposSeccion], indiceGrupo) => {
                  const visibles = camposSeccion.filter((campo) => this.campoEsVisibleEnPrueba(campo));
                  if(visibles.length===0) return null;
                  return (
                    <div className="chc-preview__seccion" key={seccion + '-' + indiceGrupo}>
                      {seccion!=='__sin_seccion__' ? <h6 className="chc-preview__seccion-titulo">{seccion}</h6> : null}
                      <div className="row">
                        {visibles.map((campo, i) => (
                          <div className={"col-md-" + campo.width} key={i}>
                            {this.renderCampoPrueba(campo)}
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}

              </div>

              <div className="modal-footer chc-prueba-modal__footer">
                <button type="button" className="btn chc-btn-cancelar" data-dismiss="modal">Cerrar prueba</button>
              </div>

            </div>
          </div>
        </div>

      </div>

    );
  }

}

export default ConfigHistoriaClinica;
